import { FixedAssetFormValueChange } from './fixed-asset-form-value-change.interface';

export interface FixedAssetsScheduleFormMovement {
    name: string;
    level: number;
    excludeFromCounting?: boolean;
    caption: string;
    costs: FixedAssetFormValueChange;
    depreciations?: FixedAssetFormValueChange;
    valueAppreciations?: FixedAssetFormValueChange;
    openingValue: number;
    closingValue: number;
    disableNumbering?: boolean;
}
